/**
 * Декор темы industrial: пять косых полосок от светло-жёлтого к оранжевому, как на слайдах.
 * На экране входа в теме mono — от белого к графиту (правило по классу .theme-stripes в index.css).
 */
const STRIPES = ['bg-primary-100', 'bg-primary-300', 'bg-primary-500', 'bg-accent-300', 'bg-accent-400'];

export default function ThemeStripes({ className = '' }: { className?: string }) {
  return (
    <div className={`theme-stripes flex gap-1.5 ${className}`} aria-hidden="true">
      {STRIPES.map((bg) => (
        <span key={bg} className={`block h-3.5 w-6 -skew-x-[24deg] ${bg}`} />
      ))}
    </div>
  );
}
